const STATUS_COLORS = {
  Pending: 'black',
  'Pre Check': 'grey',
  'Fetching Steps': 'grey',
  'In Progress': 'blue',
  Success: 'green',
  Failed: 'red',
};

let channelSubscriptionId, ownershipTransferChannel;

const handleStepClick = function (clickEvent) {
  const stepItemElmt = clickEvent.target.closest('.item');

  if (
    stepItemElmt === null ||
    stepItemElmt.dataset.status == 'Pending' ||
    stepItemElmt.classList.contains('active')
  ) {
    return;
  }

  changeCurrentStep(stepItemElmt);
};

const changeCurrentStep = function (stepItemElmt) {
  if (stepItemElmt === null) {
    return;
  }

  document.querySelectorAll('#step-list .item').forEach((stepItem) => {
    stepItem.classList.remove('active');
  });
  stepItemElmt.classList.add('active');

  const stepTitle = stepItemElmt.querySelector('.content .header').textContent;
  document.querySelector('#current-step').textContent = stepTitle;
  document.querySelector('#logs-step-title').textContent = stepTitle;

  // Add the step selected to the current history item.
  const url = new URL(window.location.href);
  url.searchParams.set(
    'step',
    Array.from(stepItemElmt.parentElement.children).indexOf(stepItemElmt),
  );
  window.history.replaceState({ htmx: true }, document.title, url);

  htmx.ajax(
    'GET',
    `${window.location.pathname}/step_log/${stepItemElmt.dataset.id}`,
    {
      target: 'pre.logs-contents',
      indicator: '#ownership-transfer-logs-loading-indicator',
      swap: 'innerHTML scroll:#scroller:top',
      replaceUrl: false,
    },
  );
};

const updateStatus = function (status) {
  const statusText = document.querySelector('#status-text');

  if (statusText.textContent == status) {
    return;
  }

  let statusContainer = statusText.closest('.ownership-transfer-status');

  statusContainer.classList.remove(...Object.values(STATUS_COLORS));
  statusContainer.classList.add(STATUS_COLORS[status]);

  statusText.textContent = status;
};

const processChannelUpdates = function (ownershipTransferData) {
  const finished = ownershipTransferIsFinished(ownershipTransferData.status);

  if (channelSubscriptionId && finished) {
    Messenger.off(ownershipTransferChannel, processChannelUpdates);
  }

  updateStatus(ownershipTransferData.status);

  if (ownershipTransferData.status_message !== undefined) {
    document.querySelector('pre.logs-contents').textContent =
      ownershipTransferData.status_message;
  }

  if (ownershipTransferData.current_step_id === undefined) {
    return;
  }

  const inProgressElmt = document.querySelector(
      '#step-list .item[data-status="In Progress"]',
    ),
    currentStepChanged =
      inProgressElmt === null ||
      inProgressElmt.dataset.index != ownershipTransferData.current_step_index;

  if (currentStepChanged || finished) {
    htmx.ajax('GET', `${window.location.pathname}/steps`, {
      target: '#step-list',
      swap: 'innerHTML',
    });
    return;
  }

  const lastCommandOutputElmt =
    document.querySelector('pre.logs-contents').lastElementChild;
  let commandOutputIdParam = '';

  if (
    lastCommandOutputElmt !== null &&
    lastCommandOutputElmt.dataset.commandOutputId !=
      ownershipTransferData.current_step_last_command_output_id
  ) {
    commandOutputIdParam = `?command_ouput_id=${lastCommandOutputElmt.dataset.commandOutputId}`;
  }

  const activeStepItem = document.querySelector('#step-list .item.active');
  if (
    activeStepItem === null ||
    activeStepItem.dataset.id != ownershipTransferData.current_step_id
  ) {
    return;
  }

  htmx.ajax(
    'GET',
    `${window.location.pathname}/step_log/${ownershipTransferData.current_step_id}${commandOutputIdParam}`,
    {
      target: 'pre.logs-contents',
      indicator: '#ownership-transfer-logs-loading-indicator',
      swap: 'beforeend scroll:#scroller:bottom',
    },
  );
};

const ownershipTransferIsFinished = function (status) {
  return ['Success', 'Failed'].includes(status);
};

const utcToBrowserTime = function (utcTime) {
  const format = 'YYYY-MM-DD hh:mm:ssa z',
    zone = moment.tz.guess(),
    date = moment.utc(utcTime);

  return date.isValid() ? date.tz(zone).format(format) : utcTime;
};

const formatLogTimestamps = function () {
  document
    .querySelectorAll('pre.logs-contents span.timestamp.utc')
    .forEach((outputTimestamp) => {
      const browserTime = utcToBrowserTime(
        outputTimestamp.textContent.match(/\[(.*)\]/)[1],
      );
      outputTimestamp.textContent = `[${browserTime}]`;
      outputTimestamp.classList.remove('utc');
    });
};

module.exports = function () {
  const ownershipTransferElmt = document.querySelector('#ownership-transfer');

  if (ownershipTransferElmt === null) {
    return;
  }

  ownershipTransferChannel = `/${currentCustomer}/ownership_transfers/${ownershipTransferElmt.dataset.id}`;

  if (!ownershipTransferIsFinished(ownershipTransferElmt.dataset.status)) {
    channelSubscriptionId = Messenger.on(
      ownershipTransferChannel,
      processChannelUpdates,
    );
  }

  const stepListElmt = document.querySelector('#step-list');

  stepListElmt.addEventListener('click', handleStepClick);
  stepListElmt.addEventListener('htmx:afterSwap', (event) => {
    changeCurrentStep(event.target.querySelector('.item.active'));
  });

  document
    .querySelector('pre.logs-contents')
    .addEventListener('htmx:afterSwap', () => {
      formatLogTimestamps();
    });
  formatLogTimestamps();

  document.addEventListener(
    'turbolinks:before-visit',
    () => {
      if (channelSubscriptionId) {
        Messenger.off(ownershipTransferChannel, processChannelUpdates);
      }
    },
    { once: true },
  );
};
